import React, { useEffect, useState } from "react";
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { mainAxios } from '../../../services/mainAxios'
import { toast } from 'react-toastify'
import { useAppContext } from '../../../AppContext'
import currencies from '../../../services/currencies.json'
import Select from 'react-select'
import selectStyle, { errorSelectStyle } from "../../../design/selectStyle";
import Loader from '../../Layout/Loader'
import { useTranslation } from "react-i18next";
import { globalHandleChange, validateForm } from "../../../services/functions";
import IBAN from "iban";

const AddEditOpenBankingAccount = ({ id,onSuccess }) => {
  const [bankList, setBankList] = useState([]);
  const [bankAccount, setBankAccount] = React.useState({
    financialInstitutionId: null,
    branch: "",
    accountNo: "",
    iban: "",
    bban: "",
    pan: "",
    currency: "",
    cashAccountType: "CHECKING",
    isOpenBanking:true,
    active: true,
  });
  const { t } = useTranslation('translations');
  const [loading, setLoading] = React.useState(false);
  const [pageLoading, setPageLoading] = React.useState(true);
  const { user: [user], selectedCompany: [selectedCompany], company: [company] } = useAppContext();
  const [errors, setErrors] = React.useState({
    financialInstitutionId: null
  });
  const isEdit = !!id;
  const companyId = company?.id;
  
  useEffect(() => {
    if (!isEdit) {
      setPageLoading(false);
      return;
    }
    mainAxios
      .get(`/api/accounts/${id}`)
      .then(res => {
        setPageLoading(false);
        const content = res.data ?? {};
        if (res.status === 200) {
          setBankAccount({...content,financialInstitutionId:content.financialInstitution?.id});
        }
      })
      .catch(() => {
        setPageLoading(false);
      });
  }, []);
  useEffect (()=> {
    mainAxios
    .get("/api/financialInstitutions")
    .then( res=>{
      if(res.status==200){
        setBankList(res.data);
      }
    })
  },[])
console.log({bankAccount})

  const valid= ()=>{
    let validateFields = [
      {
        value: "financialInstitutionId",
        label: "FinancialInstitutionId",
      },
      {
        value: "accountNo",
        label: "AccountNo",
      },
      {
        value: "currency",
        label: "Currency",
      },
      {
        value: "iban",
        label: "Iban",
        message: "Invalid IBAN, check the format",
        validation: (iban) => IBAN.isValid(iban) ,
      },
    ]
    const validationObj = validateForm(validateFields, bankAccount);
    if (!validationObj.isValid || Object.keys(validationObj.errors).length > 0) {
      toast.error(t("common.fixValidations"),{ containerId: "all_toast" })
      setErrors(validationObj.errors);
      return false;
    }
    return true
  }

  const editBankAccount = (e) => {
    e.preventDefault();
    if(!valid()){
      return;
    }
    const {financialInstitution,...restBankAccount} = bankAccount
    setLoading(true);
    mainAxios[id?'put':"post"]('/api/accounts'+(id?`/${id}`:""), {
      ...restBankAccount,
      companyId:!!id ? bankAccount.companyId: companyId,
      noWrapperData: true
    }).then(res => {
      if (res.status === 200) {
        if(onSuccess){
          onSuccess()
        }
        toast.success(t(['toast.editBankAccount']), {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          progress: undefined,
          containerId: "all_toast"
        });
      }
      setLoading(false);
    })
    .catch(err=>{
      setLoading(false);

    })
  };

  const handleInputChange = (key, value) => {
    setErrors((errors) => ({ ...errors, [key]: null }))
    globalHandleChange({ key, value, setState:setBankAccount })
  }

  if (pageLoading && !!id) {
    return <Loader />;
  }

  return (
    <div className="row">
      <form onSubmit={editBankAccount} className="col-12 mx-auto">
        <div className="row">
          <div className="col-12 pb-1">
            <div className="form-group mb-1">
              <label htmlFor="financialInstitutionId">
                {t("openBanking.financialInstitution")}
              </label>
              <span className="text-danger"> *</span>
              <Select
                options={bankList ?? []}
                styles={errors?.financialInstitutionId?errorSelectStyle: selectStyle}
                isSearchable={true}
                getOptionLabel={(opt) => opt.name}
                getOptionValue={(opt) => opt.id}
                value={bankList.find(
                  (bank) =>
                    bank.id === (bankAccount?.financialInstitutionId)
                )}
                onChange={(selectedBank) => {
                  console.log({ selectedBank })
                  handleInputChange("financialInstitutionId", selectedBank.id)
                }}
                name="financialInstitutionId"
                placeholder={bankAccount?.financialInstitution?.name ?? ""}
              />
              {errors?.financialInstitutionId && (
                <div className="text-danger mt-1">
                  {t("common.selectOption")}
                </div>
              )}
            </div>
          </div>
          <div className="col-12 pb-1 pt-0">
            <div className="form-group mb-1">
              <label htmlFor="branch">{t(["bankAccount.accountName"])}</label>
              <input
                type="text"
                className="form-control"
                id="branch"
                placeholder="E.g 'Bank Name - ALL"
                value={bankAccount.branch}
                onChange={(e) => handleInputChange("branch", e.target.value)}
              />
            </div>
          </div>
          <div className="col-12 pb-1 pt-0">
            <div className="form-group mb-1">
              <label htmlFor="accountNo">{t("bankAccount.accountNo")}</label>
              <span className="text-danger"> *</span>
              <input
                type="text"
                className={`form-control ${errors.accountNo ? "is-invalid" : "" } `}
                id="accountNo"
                placeholder="E.g '1234567849'"
                value={bankAccount.accountNo}
                onChange={(e) => handleInputChange("accountNo", e.target.value)}
              />
              {errors?.accountNo && (
                 <div className="invalid-feedback">{errors?.accountNo?.message}</div>
              )}
            </div>
          </div>
          <div className="col-12 pb-1 pt-0">
            <div className="form-group mb-1">
              <label htmlFor="iban">IBAN</label>
              <span className="text-danger"> *</span>
              <input
                type="text"
                className={`form-control ${errors?.iban ? "is-invalid" : "" } `}
                id="iban"
                placeholder="E.g 'AL472121100900000002356987731'"
                value={bankAccount.iban}
                onChange={(e) => handleInputChange("iban", e.target.value)}
              />
              {errors?.iban && ( <div className="invalid-feedback">{errors?.iban?.message}</div>)}
            </div>
          </div>
          <div className="col-12 pb-1 pt-0">
            <div className="form-group mb-1">
              <label htmlFor="bban">BBAN</label>
              <input
                type="text"
                className="form-control"
                id="bban"
                name="bban"
                placeholder="E.g '1009000000023569874155'"
                value={bankAccount.bban}
                onChange={(e) => handleInputChange("bban", e.target.value)}
              />
            </div>
          </div>
          <div className="col-12 pb-1 pt-0">
            <div className="form-group mb-1">
              <label htmlFor="pan">PAN</label>
              <input
                type="text"
                className="form-control"
                id="pan"
                name="pan"
                placeholder="E.g '456789******12344'"
                value={bankAccount.pan}
                onChange={(e) => handleInputChange("pan", e.target.value)}
              />
            </div>
          </div>
          {/* <div className="col-12">
            <div className="form-group">
              <label htmlFor="maskedPan">Masked PAN</label>
              <input
                type="text"
                className="form-control"
                id="maskedPan"
                name="maskedPan"
                placeholder="E.g '456789******12353'"
                value={bankAccount.maskedPan}
                onChange={(e) => handleInputChange("maskedPan", e.target.value)}
              />
            </div>
          </div> */}
          <div className="col-12 pb-1 pt-0">
            <div className="form-group mb-1">
              <label htmlFor="currency">{t("invoice.currency")}</label>
              <span className="text-danger"> *</span>
              <Select
                styles={errors?.currency? errorSelectStyle: selectStyle}
                options={currencies}
                value={currencies.find(
                  (currency) => currency.value === bankAccount.currency
                )}
                isSearchable={true}
                onChange={(currency) =>
                  handleInputChange("currency", currency.value)
                }
                name="currency"
              />
              {errors?.currency && (
                <div className="text-danger mt-1">
                  {t("common.selectOption")}
                </div>
              )}
            </div>
          </div>
          <div className="col-12 pb-1 pt-0">
            <div className="form-group mb-1">
              <label htmlFor="cashAccountType">Cash Account Type</label>
              <Select
                styles={selectStyle}
                options={[
                  { value: "CHECKING", label: "Checking" },
                  { value: "SAVINGS", label: "Savings" },
                  { value: "CURRENT", label: "Current" },
                ]}
                value={[
                  {
                    value: bankAccount.cashAccountType,
                    label: bankAccount.cashAccountType,
                  },
                ]}
                isSearchable={true}
                onChange={(type) =>
                  handleInputChange("cashAccountType", type.value)
                }
                name="cashAccountType"
              />
            </div>
          </div>
          <div className="d-flex ">
             <div className="custom-control custom-checkbox mt-1">
              <input
                type="checkbox"
                className="custom-control-input"
                id="active"
                name="active"
                checked={bankAccount.active}
                onChange={(e) =>
                   handleInputChange("active", e.target.checked)
                }
              />
              <label
                style={{ paddingTop: "3px", paddingLeft: "2px" }}
                htmlFor="active"
                className="custom-control-label"
              >
                {t("company.active")}
              </label>
            </div> 
            <div className="custom-control custom-checkbox mt-1 mb-3 pl-3">
              <input
                type="checkbox"
                className="custom-control-input"
                id="isOpenBanking"
                name="isOpenBanking"
                checked={bankAccount.isOpenBanking}
                onChange={(e) =>
                   handleInputChange("isOpenBanking", e.target.checked)

                }
              />
              <label
                style={{ paddingTop: "3px", paddingLeft: "2px" }}
                htmlFor="isOpenBanking"
                className="custom-control-label"
              >
                Is Open Banking
              </label>
          </div>
          </div>
          <div className="col-12 pb-1 pt-0">
            <button
              type="submit"
              disabled={loading}
              style={{ minWidth: "100px" }}
              className="btn btn-primary"
            >
              {loading ? (
                <Loader size="xs" color="white" />
              ) : (
                <>
                  <FontAwesomeIcon icon={faCheck} className="mr-2" />
                  {t("common.save")}
                </>
              )}
            </button>
          </div>
        </div>
      </form>
    </div>
  )
};

export default AddEditOpenBankingAccount;